/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsBankAccountPaymentViewModel } from './PaymentDetailsBankAccountPaymentViewModel';
import {
    PaymentDetailsBankAccountPaymentViewModelFromJSON,
    PaymentDetailsBankAccountPaymentViewModelFromJSONTyped,
    PaymentDetailsBankAccountPaymentViewModelToJSON,
} from './PaymentDetailsBankAccountPaymentViewModel';
import type { PaymentDetailsInternalInvestmentPaymentViewModel } from './PaymentDetailsInternalInvestmentPaymentViewModel';
import {
    PaymentDetailsInternalInvestmentPaymentViewModelFromJSON,
    PaymentDetailsInternalInvestmentPaymentViewModelFromJSONTyped,
    PaymentDetailsInternalInvestmentPaymentViewModelToJSON,
} from './PaymentDetailsInternalInvestmentPaymentViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsRegularWithdrawalViewModel
 */
export interface PaymentDetailsRegularWithdrawalViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsRegularWithdrawalViewModel
     */
    productIncomeId: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsRegularWithdrawalViewModel
     */
    isLivingAnnuity: boolean;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsRegularWithdrawalViewModel
     */
    totalAmount: number;
    /**
     * 
     * @type {PaymentDetailsBankAccountPaymentViewModel}
     * @memberof PaymentDetailsRegularWithdrawalViewModel
     */
    bankAccountPayment?: PaymentDetailsBankAccountPaymentViewModel;
    /**
     * 
     * @type {PaymentDetailsInternalInvestmentPaymentViewModel}
     * @memberof PaymentDetailsRegularWithdrawalViewModel
     */
    internalInvestmentPayment?: PaymentDetailsInternalInvestmentPaymentViewModel;
}

/**
 * Check if a given object implements the PaymentDetailsRegularWithdrawalViewModel interface.
 */
export function instanceOfPaymentDetailsRegularWithdrawalViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productIncomeId" in value;
    isInstance = isInstance && "isLivingAnnuity" in value;
    isInstance = isInstance && "totalAmount" in value;

    return isInstance;
}

export function PaymentDetailsRegularWithdrawalViewModelFromJSON(json: any): PaymentDetailsRegularWithdrawalViewModel {
    return PaymentDetailsRegularWithdrawalViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsRegularWithdrawalViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsRegularWithdrawalViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productIncomeId': json['ProductIncomeId'],
        'isLivingAnnuity': json['IsLivingAnnuity'],
        'totalAmount': json['TotalAmount'],
        'bankAccountPayment': !exists(json, 'BankAccountPayment') ? undefined : PaymentDetailsBankAccountPaymentViewModelFromJSON(json['BankAccountPayment']),
        'internalInvestmentPayment': !exists(json, 'InternalInvestmentPayment') ? undefined : PaymentDetailsInternalInvestmentPaymentViewModelFromJSON(json['InternalInvestmentPayment']),
    };
}

export function PaymentDetailsRegularWithdrawalViewModelToJSON(value?: PaymentDetailsRegularWithdrawalViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProductIncomeId': value.productIncomeId,
        'IsLivingAnnuity': value.isLivingAnnuity,
        'TotalAmount': value.totalAmount,
        'BankAccountPayment': PaymentDetailsBankAccountPaymentViewModelToJSON(value.bankAccountPayment),
        'InternalInvestmentPayment': PaymentDetailsInternalInvestmentPaymentViewModelToJSON(value.internalInvestmentPayment),
    };
}

